export default __webpack_public_path__ + "static/media/noaa.3415f999.png";